export const EVENTS = [
  'afterLoad',
  'onLeave',
  'afterRender',
  'afterResize',
  'afterResponsive',
  'afterSlideLoad',
  'onSlideLeave',
];

export const METHODS = [
  'moveSectionUp',
  'moveSectionDown',
  'moveTo',
  'silentMoveTo',
  'moveSlideRight',
  'moveSlideLeft',
  'setAutoScrolling',
  'setFitToSection',
  'fitToSection',
  'setLockAnchors',
  'setAllowScrolling',
  'setKeyboardScrolling',
  'setRecordHistory',
  'setScrollingSpeed',
  'destroy',
  'reBuild',
  'setResponsive',
  'responsiveSlidesToSections',
  'responsiveSlidesToSlides',
];


//////////////////
// WEBPACK FOOTER
// ./~/vue-fullpage.js/src/constants.js
// module id = 166
// module chunks = 0